<div class="select-gamemode">
  <a class="button black medium-2" routerLink="/provably-fair" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }">How it works?</a>
  <a class="button black medium-2" routerLink="/provably-fair/jackpot" [class.selected]="selectedGamemode === 'jackpot'" (click)="selectGamemode('jackpot')">Jackpot</a>
  <a class="button black medium-2" routerLink="/provably-fair/coinflip" [class.selected]="selectedGamemode === 'coinflip'" (click)="selectGamemode('coinflip')">Coinflip</a>
  <a class="button black medium-2" routerLink="/provably-fair/plinko" [class.selected]="selectedGamemode === 'plinko'" (click)="selectGamemode('plinko')">Plinko</a>
  <a class="button black medium-2" routerLink="/provably-fair/caseopening" [class.selected]="selectedGamemode === 'caseopening'" (click)="selectGamemode('caseopening')"
    >Case Opening</a
  >
  <a class="button black medium-2" routerLink="/provably-fair/casebattles" [class.selected]="selectedGamemode === 'casebattles'" (click)="selectGamemode('casebattles')"
    >Case Battles</a
  >
  <a class="button black medium-2" routerLink="/provably-fair/mines" [class.selected]="selectedGamemode === 'mines'" (click)="selectGamemode('mines')">Mines</a>
  <a class="button black medium-2" routerLink="/provably-fair/towers" [class.selected]="selectedGamemode === 'towers'" (click)="selectGamemode('towers')">Towers</a>
  <a class="button black medium-2" routerLink="/provably-fair/serialId" [class.selected]="selectedGamemode === 'serialId'" (click)="selectGamemode('serialId')">Serial Database</a>
  <a class="button black medium-2" routerLink="/provably-fair/king" [class.selected]="selectedGamemode === 'king'" (click)="selectGamemode('king')">King</a>
</div>

<div class="sides-wrapper">
  <div class="side left">
    @if(selectedGamemode === null){
    <div class="title">Provably Fair</div>
    <div class="info container-style-primary">
      We use the popular third party system Random.org as an independent source to determine the outcome of all of our games. Random.org allows anyone to verify the true randomness
      of a generated seed that is used.
    </div>
    }
    <div class="title">How it works</div>
    <div class="info container-style-primary">
      @if(selectedGamemode === 'jackpot' || selectedGamemode === 'coinflip'){
      <p>
        The module (%) which determines the outcome of both Jackpot and Coinflip games is generated using a server seed and a seed from random.org. The server seed is generated as
        the new round is saved in our system, and we reach out to random.org when no more bets are accepted so we can't modify the outcome. Random.org has a serialized system and
        we track each serial ID, this proves we didn't reach out multiple times to get a favorable outcome. Our Provably Fair System is set up in a fully transparent way that
        allows no tampering from anyone. Feel free to verify your games here and calculate the % on your own end. We use chance.js to generate the final result.
      </p>
      } @if(selectedGamemode === 'plinko'){
      <p>
        On Plinko we have a somewhat different system. We give you your unique client seed which you can modify at any time on this page and we also generate a Random.org seed
        which you can regenerate every 10 Plinko Games if you wish. Then we use a nonce to generate the outcomes for your Plinko games using the following string:
        client_seed-server_seed-i . The nonce "i" is increased for every ball you drop and it's reset when you change any of the two seeds. We generate a Winning Ticket using
        Chance.JS with this seed and we use our Plinko Table to determine the outcome of your game. Your previous Random.Org Seed only becomes available once you change it.
      </p>
      } @if(selectedGamemode === 'caseOpening'){
      <p>
        Both Case Opening and Case Battles work almost like Plinko.<br />
        On Case Opening, we use the Server Seed we generated for you, your Client Seed and your nonce (which you share with Plinko) is the last ingredient to generate a number
        between 1-100000 which we'll use to calculate the item you won.<br />
        The string is the same: client_seed-server_seed-i. Your nonce is increased by 1 for every wager you make, just like Plinko.
      </p>
      } @if(selectedGamemode === 'caseBattles'){
      <p>
        Both Case Opening and Case Battles work almost like Plinko.<br />
        On Case Opening, we use the Server Seed we generated for you, your Client Seed and your nonce (which you share with Plinko) is the last ingredient to generate a number
        between 1-100000 which we'll use to calculate the item you won.<br />
        The string is the same: client_seed-server_seed-i. Your nonce is increased by 1 for every wager you make, just like Plinko.
      </p>
      } @if(selectedGamemode === 'caseBattles'){
      <p>
        As we said, Cases and Plinko's Provably Fairness work on the same principal - we generate a Server Seed when the Lobby is Hosted (no Client seeds) and when everyone is
        locked in we reach out to Random.ORG for the Random Seed.<br />
        We combine the two, add a nonce that goes up from 1 to the amount of rounds and users in total (rounds*participants) and then we spread the results between the users in
        joining order for each round. The generation of the results is the same as the regular Case Opening.
      </p>
      } @if(selectedGamemode === 'mines' || selectedGamemode === 'towers'){
      <p>
        On Mines and Towers we use the usual Client Seed method which we use for Plinko and Solo Case opening, This means your Client Seed, Sever Seed and general Nonce is used to
        generate the outcome. On Towers, we generate the outcome 9 times for each row with a unique nonce 0-8 for each row. We use this method for the selected gamemode:
      </p>
      } @if (selectedGamemode === 'jackpot' || selectedGamemode === 'coinflip' || selectedGamemode === 'serialId') {
      <div class="code">
        var chance = new ChanceJS(server_seed + '-' + random_seed); <br />
        var percentage = chance.floating({{ '{' }}min: 0, max: 100, fixed: 6{{ '}' }});
      </div>
      } @if (selectedGamemode === 'plinko') {
      <div class="code">
        // payouts table json file can be found here: https://skinbet.gg/plinko_tables.json<br />
        var gen_seed=obj.client_seed+'-'+obj.server_seed+'-'+i;<br />
        var chance = new ChanceJS(gen_seed);<br />
        var winningTicket = chance.floating({{ '{' }}min: 0, max: 100, fixed: 9{{ '}' }});<br /><br />
        for(let h = 0;h < plinkoRow.payouts.length;h++) // plinkoRow.payouts is from the risk-rows combination from plinko_tables.json<br />
        {{ '{' }}<br />
        <div style="width: 1.25rem; height: 1px; display: inline-block"></div>
        let multiplier = plinkoRow.payouts[h];<br />
        <div style="width: 1.25rem; height: 1px; display: inline-block"></div>
        winningTicket -= multiplier.chance;<br />
        <div style="width: 1.25rem; height: 1px; display: inline-block"></div>
        if(chance <= 0)<br />
        <div style="width: 1.25rem; height: 1px; display: inline-block"></div>
        {{ '{' }}<br />
        <div style="width: 2.5rem; height: 1px; display: inline-block"></div>
        winningPocket = h;<br />
        <div style="width: 2.5rem; height: 1px; display: inline-block"></div>
        break;<br />
        <div style="width: 2.5rem; height: 1px; display: inline-block"></div>
        {{ '}' }}<br />
        {{ '}' }}<br />
        let winningMultiplier = plinkoRow.payouts[winningPocket];<br />
      </div>
      } @if (selectedGamemode === 'caseopening') {
      <div class="code">
        var gen_seed=obj.client_seed+'-'+obj.server_seed+'-'+i;<br />
        var chancejs = new ChanceJS(gen_seed);<br />
        var winningTicket = chancejs.integer({{ '{' }}min: 0, max: 100000{{ '}' }});<br /><br />
        for(let h = 0;h < this_case.skins.length;h++) // All Skins in the Case , ordered by "price" ascending<br />
        {{ '{' }}<br />
        <div style="width: 1.25rem; height: 1px; display: inline-block"></div>
        let multiplier = this_case.skins[h];<br />
        <div style="width: 1.25rem; height: 1px; display: inline-block"></div>
        winningTicket -= multiplier.chance;<br />
        <div style="width: 1.25rem; height: 1px; display: inline-block"></div>
        if(winningTicket <= 0) {{ '{' }} // winningTicket is below 0 which means we found the winning multiplier and the item's position in the array<br />
        <div style="width: 2.5rem; height: 1px; display: inline-block"></div>
        winningPocket = h;<br />
        <div style="width: 2.5rem; height: 1px; display: inline-block"></div>
        break;<br />
        <div style="width: 1.25rem; height: 1px; display: inline-block"></div>
        {{ '}' }}<br />
        {{ '}' }}<br />
        var skin_opened=this_case.skins[winningPocket];
      </div>
      } @if (selectedGamemode === 'casebattles') {
      <div class="code">
        var gen_seed=obj.server_seed+'-'+obj.random_seed+'-'+i;<br />
        var chancejs = new ChanceJS(gen_seed);<br />
        var winningTicket = chancejs.integer({{ '{' }}min: 0, max: 100000{{ '}' }});
      </div>
      } @if (selectedGamemode === 'mines') {
      <div class="code">
        var grid=size_of_the_minefield;<br />
        var gen_seed=seed.client_seed+'-'+seed.random_seed+'-'+seed.nonce;<br />
        var chancejs = new ChanceJS(gen_seed); <br />
        var mines=chancejs.unique(chancejs.integer, mines, {{ '{' }}min: 1, max: grid{{ '}' }});
      </div>
      } @if (selectedGamemode === 'towers') {
      <div class="code">
        var death_tiles=death_tiles_per_row;<br />
        var gen_seed=main_seed+'-'+i; // i = 0,1,2,3,4,5,6,7,8<br />
        var chancejs = new ChanceJS(gen_seed);<br />
        var death_tiles=chancejs.unique(chancejs.integer, death_tiles, {{ '{' }}min: 0, max: max_tiles_per_row-1{{ '}' }});
      </div>
      }
    </div>
  </div>
  <div class="spacer"></div>
  <div class="side right">
    <div class="title">Verify</div>
    <div class="container container-style-primary">
      <div class="sub-title orange">Enter {{ selectedGamemode === 'casebattles' ? 'Round Unique Identifier' : 'Round ID' }}</div>
      <div class="round-id">
        <div class="input-group">
          <input type="text" placeholder="Enter the Round ID here..." [(ngModel)]="roundId" />
          <div class="label">Round ID</div>
        </div>
        <button class="button red medium-2" (click)="verifyRound()">Verify</button>
      </div>
      @if (jackpotInfo) {
      <div class="information">
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="jackpotInfo.winner.name | name" disabled />
            <div class="label">Winner</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="jackpotInfo.value" disabled />
            <div class="label">Jackpot Value</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="jackpotInfo.module" disabled />
            <div class="label">Module</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="jackpotInfo.hash" disabled />
            <div class="label">Hash</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="jackpotInfo.serialid" disabled />
            <div class="label">Serial ID</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="jackpotInfo.server_seed" disabled />
            <div class="label">Server Seed</div>
          </div>
        </div>
        <div class="input-group">
          <input type="text" [value]="jackpotInfo.random_seed" disabled />
          <div class="label">Random Seed</div>
        </div>
      </div>
      } @if (coinflipInfo) {
      <div class="information">
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="coinflipInfo.host.name | name" disabled />
            <div class="label">Host Name</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="coinflipInfo.part.name | name" disabled />
            <div class="label">Participant Name</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="coinflipInfo.winner.name | name" disabled />
            <div class="label">Winner Name</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="coinflipInfo.module" disabled />
            <div class="label">Module</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="coinflipInfo.hash" disabled />
            <div class="label">Hash</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="coinflipInfo.serialid" disabled />
            <div class="label">Serial ID</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="coinflipInfo.server_seed" disabled />
            <div class="label">Server Seed</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="coinflipInfo.random_seed" disabled />
            <div class="label">Random Seed</div>
          </div>
        </div>
      </div>
      } @if (serialidInfo) {
      <div class="information">
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="serialidInfo.server_seed" disabled />
            <div class="label">Server Seed</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="serialidInfo.random_seed" disabled />
            <div class="label">Random Seed</div>
          </div>
        </div>
        <div class="textarea-group">
          <div class="label">Signature</div>
          <textarea disabled>{{ serialidInfo.signature }}</textarea>
        </div>
        <div class="textarea-group">
          <div class="label">Random</div>
          <textarea disabled>{{ serialidInfo.random }}</textarea>
        </div>
      </div>
      } @if (plinkoInfo) {
      <div class="information">
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="plinkoInfo.serialid" disabled />
            <div class="label">Serial ID</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="plinkoInfo.nonce" disabled />
            <div class="label">Nonce</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="plinkoInfo.client_seed" disabled />
            <div class="label">Client Seed</div>
          </div>
        </div>
      </div>
      } @if (caseUnboxInfo) {
      <div class="information">
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="caseUnboxInfo.serialid" disabled />
            <div class="label">Serial ID</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="caseUnboxInfo.nonce" disabled />
            <div class="label">Nonce</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="caseUnboxInfo.client_seed" disabled />
            <div class="label">Client Seed</div>
          </div>
        </div>
      </div>
      } @if (minesInfo) {
      <div class="information">
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="minesInfo.serialid" disabled />
            <div class="label">Serial ID</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="minesInfo.nonce" disabled />
            <div class="label">Nonce</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="minesInfo.client_seed" disabled />
            <div class="label">Client Seed</div>
          </div>
        </div>
      </div>
      } @if (towersInfo) {
      <div class="information">
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="towersInfo.serialid" disabled />
            <div class="label">Serial ID</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="towersInfo.nonce" disabled />
            <div class="label">Nonce</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="towersInfo.client_seed" disabled />
            <div class="label">Client Seed</div>
          </div>
        </div>
      </div>
      } @if ((selectedGamemode === 'plinko' || selectedGamemode === 'caseopening' || selectedGamemode === 'mines' || selectedGamemode === 'towers') && session.profile()) {
      <div class="sub-title orange">Client Seed</div>
      <div class="row">
        <div class="input-group">
          <input type="text" [(ngModel)]="clientSeed" />
          <div class="label">Client Seed</div>
        </div>
        <button class="button black medium-2" [class.btn-primary]="clientSeed !== session.clientSeed" (click)="updateClientSeed()">Save</button>
      </div>
      <div class="sub-title orange">Random.org seed hash</div>
      <div class="row">
        <div class="input-group">
          <input type="text" [(ngModel)]="session.randomSeed.seed" disabled />
          <div class="label">Random Seed Hash</div>
        </div>
        <div class="input-group">
          <input type="text" [(ngModel)]="session.randomSeed.serial" disabled />
          <div class="label">Serial ID</div>
        </div>
        <button class="button red medium-2" (click)="updateRandomSeed()">Regenerate</button>
      </div>
      } @if (caseBattlesInfo) {
      <div class="information">
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="caseBattlesInfo.gameid" disabled />
            <div class="label">Battle ID</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="caseBattlesInfo.serialid" disabled />
            <div class="label">Serial ID</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="caseBattlesInfo.hash" disabled />
            <div class="label">Hash</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="caseBattlesInfo.random_seed" disabled />
            <div class="label">Random Seed</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="caseBattlesInfo.client_seed" disabled />
            <div class="label">Client Seed</div>
          </div>
        </div>
      </div>
      } @if(kingInfo){
      <div class="information">
        @for (king of kingInfo; track $index) {
        <div class="grid">
          <div class="input-group">
            <input type="text" [value]="king.king.name | name" disabled />
            <div class="label">King</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="king.opponent.name | name" disabled />
            <div class="label">Opponent</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="king.winner.name | name" disabled />
            <div class="label">Winner</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="king.winner.value" disabled />
            <div class="label">Winnings</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="king.module" disabled />
            <div class="label">Module</div>
          </div>
          <div class="input-group">
            <input type="text" [value]="king.hash" disabled />
            <div class="label">Hash</div>
          </div>
        </div>
        <div class="input-group">
          <input type="text" [value]="king.serialid" disabled />
          <div class="label">Serial Id</div>
        </div>
        <div class="input-group">
          <input type="text" [value]="king.server_seed" disabled />
          <div class="label">Server Seed</div>
        </div>
        <div class="input-group">
          <input type="text" [value]="king.fled" disabled />
          <div class="label">King Fled</div>
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>
